import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["phases", "repeats", "sessionsPerWeek", "weeks", "totalSessions", "phasesDisplay"]
  static values = {
    templateId: String
  }

  connect() {
    // Set event listener for template selection
    const templateSelect = document.querySelector('select[name="exercise_schedule[exercise_schedule_template_id]"]')
    if (templateSelect) {
      templateSelect.addEventListener('change', this.templateChanged.bind(this))
      
      // If a template is already selected, fetch its phases
      if (templateSelect.value) {
        this.fetchTemplatePhases(templateSelect.value)
      } else {
        // Initialize calculations with default values
        this.updateCalculations()
      }
    } else {
      // Initialize calculations with default values
      this.updateCalculations()
    }
  }

  disconnect() {
    // Clean up event listeners when disconnecting
    const templateSelect = document.querySelector('select[name="exercise_schedule[exercise_schedule_template_id]"]')
    if (templateSelect) {
      templateSelect.removeEventListener('change', this.templateChanged.bind(this))
    }
  }

  templateChanged(event) {
    const templateId = event.target.value
    if (templateId) {
      this.fetchTemplatePhases(templateId)
    } else {
      // No template selected, reset to default
      if (this.hasPhasesTarget) {
        this.phasesTarget.value = 2
      }
      if (this.hasPhasesDisplayTarget) {
        this.phasesDisplayTarget.innerHTML = `
          <p class="text-sm text-blue-700">
            <span class="font-medium">Aantal fases in template:</span> 
            <span class="font-bold">2</span>
          </p>
        `
      }
      this.updateCalculationsFromPhases()
    }
  }

  fetchTemplatePhases(templateId) {
    // Fetch the template data to get the number of phases
    fetch(`/exercise_schedule_templates/${templateId}.json`)
      .then(response => response.json())
      .then(data => {
        // Set the phases value in the hidden field
        const phasesValue = data.phases || 2
        console.log("Fetched phases:", phasesValue)
        
        if (this.hasPhasesTarget) {
          this.phasesTarget.value = phasesValue
        }
        
        // Update the phases display
        if (this.hasPhasesDisplayTarget) {
          console.log("Updating phases display")
          this.phasesDisplayTarget.innerHTML = `
            <p class="text-sm text-blue-700">
              <span class="font-medium">Aantal fases in template:</span> 
              <span class="font-bold">${phasesValue}</span>
            </p>
          `
        } else {
          console.log("No phasesDisplay target found")
        }
        
        // Trigger recalculation with phases as the source
        this.updateCalculationsFromPhases()
      })
      .catch(error => {
        console.error("Error fetching template data:", error)
      })
  }

  updateCalculationsFromPhases() {
    // Get current values
    const phases = parseInt(this.hasPhasesTarget ? this.phasesTarget.value : 2) || 1
    const sessionsPerWeek = parseInt(this.hasSessionsPerWeekTarget ? this.sessionsPerWeekTarget.value : 2) || 2
    const weeks = parseInt(this.hasWeeksTarget ? this.weeksTarget.value : 6) || 6
    
    // Calculate total sessions based on current weeks and sessions per week
    const totalSessions = sessionsPerWeek * weeks
    if (this.hasTotalSessionsTarget) {
      this.totalSessionsTarget.value = totalSessions
    }
    
    // Calculate repeats per phase based on total sessions and NEW phases
    const calculatedRepeats = Math.round(totalSessions / phases)
    if (this.hasRepeatsTarget) {
      this.repeatsTarget.value = calculatedRepeats
    }
  }

  updateCalculations(event) {
    // Determine which field triggered the update
    const sourceElement = event ? event.target : null
    
    // Get current values
    const phases = parseInt(this.hasPhasesTarget ? this.phasesTarget.value : 2) || 1
    const repeats = parseInt(this.hasRepeatsTarget ? this.repeatsTarget.value : 1) || 1
    const sessionsPerWeek = parseInt(this.hasSessionsPerWeekTarget ? this.sessionsPerWeekTarget.value : 1) || 1
    const weeks = parseInt(this.hasWeeksTarget ? this.weeksTarget.value : 1) || 1
    const totalSessions = parseInt(this.hasTotalSessionsTarget ? this.totalSessionsTarget.value : 1) || 1

    // Perform calculations based on which field was changed
    if (sourceElement === this.sessionsPerWeekTarget || sourceElement === this.weeksTarget) {
      // Calculate total sessions from sessions per week and weeks
      const calculatedTotal = sessionsPerWeek * weeks
      if (this.hasTotalSessionsTarget) {
        this.totalSessionsTarget.value = calculatedTotal
      }
      
      // Calculate repeats per phase based on total sessions and phases
      const calculatedRepeats = Math.round(calculatedTotal / phases)
      if (this.hasRepeatsTarget) {
        this.repeatsTarget.value = calculatedRepeats
      }
    } 
    else if (sourceElement === this.totalSessionsTarget) {
      // Calculate weeks based on total sessions and sessions per week
      const calculatedWeeks = Math.round(totalSessions / sessionsPerWeek)
      if (this.hasWeeksTarget) {
        this.weeksTarget.value = calculatedWeeks
      }
      
      // Calculate repeats per phase based on total sessions and phases
      const calculatedRepeats = Math.round(totalSessions / phases)
      if (this.hasRepeatsTarget) {
        this.repeatsTarget.value = calculatedRepeats
      }
    }
    else if (sourceElement === this.repeatsTarget) {
      // Calculate total sessions based on phases and repeats
      const calculatedTotal = phases * repeats
      if (this.hasTotalSessionsTarget) {
        this.totalSessionsTarget.value = calculatedTotal
      }
      
      // Calculate weeks based on total sessions and sessions per week
      const calculatedWeeks = Math.round(calculatedTotal / sessionsPerWeek)
      if (this.hasWeeksTarget) {
        this.weeksTarget.value = calculatedWeeks
      }
    }
    else if (sourceElement === this.phasesTarget || !sourceElement) {
      // When phases change (or on initial load), recalculate total sessions
      const calculatedTotal = phases * repeats
      if (this.hasTotalSessionsTarget) {
        this.totalSessionsTarget.value = calculatedTotal
      }
      
      // Calculate weeks based on total sessions and sessions per week
      const calculatedWeeks = Math.round(calculatedTotal / sessionsPerWeek)
      if (this.hasWeeksTarget) {
        this.weeksTarget.value = calculatedWeeks
      }
    }
  }
}